var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 27.4286C13.8919 27.4286 15.4268 25.8937 15.4268 24H8.57283C8.57283 25.8937 10.1076 27.4286 11.9998 27.4286ZM23.5385 19.4084C22.5035 18.2963 20.5669 16.6232 20.5669 11.1429C20.5669 6.98036 17.6484 3.64821 13.713 2.83071V1.71429C13.713 0.767679 12.9459 0 11.9998 0C11.0537 0 10.2866 0.767679 10.2866 1.71429V2.83071C6.35122 3.64821 3.43265 6.98036 3.43265 11.1429C3.43265 16.6232 1.49604 18.2963 0.461043 19.4084C0.139614 19.7539 -0.00288567 20.167 -0.000207102 20.5714C0.00568575 21.45 0.69515 22.2857 1.71944 22.2857H22.2801C23.3044 22.2857 23.9944 21.45 23.9998 20.5714C24.0025 20.167 23.86 19.7534 23.5385 19.4084Z",
    fill: "#F6F5F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.be2eab51f654bd983350cf29de1e2fd1.svg";
export { ForwardRef as ReactComponent };